import React from "react";
import { PRIORITY_COLORS } from "../../../liveIncidents/models/incidents";

const STATUS_LABELS = {
  REPORTED: "Reported",
  CONFIRMED: "Confirmed",
  SCHEDULED: "Scheduled",
  RESOLVED: "Resolved",
  REJECTED: "Rejected",
};

const IncidentsSection = ({ incidents = [], onIncidentClick }) => (
  <div className="border-t border-gray-100 px-4 py-4 dark:border-white/10">
    <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
      Recent Incidents
    </p>

    {incidents.length === 0 ? (
      <p className="text-xs text-gray-400 dark:text-gray-500">
        No incidents recorded for this segment.
      </p>
    ) : (
      <ul className="space-y-2">
        {incidents.map((inc) => (
          <li key={inc.id}>
            <button
              onClick={() => onIncidentClick(inc.id)}
              className="w-full rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5 text-left transition-colors hover:border-brand-200 hover:bg-brand-50 dark:border-white/10 dark:bg-navy-700 dark:hover:border-brand-400/30 dark:hover:bg-navy-600"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-mono text-xs text-gray-400">{inc.id}</span>
                <span
                  className="h-2.5 w-2.5 shrink-0 rounded-full"
                  style={{ backgroundColor: PRIORITY_COLORS[inc.priority] }}
                  title={inc.priority}
                />
              </div>
              <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{inc.timestamp}</p>
              <span className="mt-1.5 inline-block rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-navy-600 dark:text-gray-300">
                {STATUS_LABELS[inc.status] ?? inc.status}
              </span>
            </button>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default IncidentsSection;
